import { QueryObserverBaseResult, useQuery } from "react-query";
import { queryKeys } from "../../query";
import api from "../../client";
import { UserInfoResponseData } from "../../types/user";

export const getData = async (): Promise<UserInfoResponseData> => {
  const { data } = await api.get<UserInfoResponseData>(`/user/info`);

  return data;
};

export const useUserInfo =
  (): QueryObserverBaseResult<UserInfoResponseData> => {
    const { data, ...props } = useQuery(queryKeys.userInfo(), () => getData());
    return { data, ...props };
  };
